import { v4 as uuidv4 } from "uuid";
import userImagePlaceholder1 from "@circle-react-shared/BuilderUI/Assets/user_5_image_placeholder.png";
import userImagePlaceholder2 from "@circle-react-shared/BuilderUI/Assets/user_6_image_placeholder.png";
import userImagePlaceholder3 from "@circle-react-shared/BuilderUI/Assets/user_7_image_placeholder.png";
import userImagePlaceholder4 from "@circle-react-shared/BuilderUI/Assets/user_8_image_placeholder.png";
import userImagePlaceholder5 from "@circle-react-shared/BuilderUI/Assets/user_9_image_placeholder.png";
import userImagePlaceholder6 from "@circle-react-shared/BuilderUI/Assets/user_10_image_placeholder.png";
import { TABLET_WIDTH } from "@circle-react-shared/BuilderUI/Canvas/constants";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import {
  createH2Block,
  createPBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import {
  getMarginOptions,
  getPaddingOptions,
} from "@circle-react-shared/BuilderUI/utils/boxModelStyleHelpers";
import { getBackgroundColorOptions } from "@circle-react-shared/BuilderUI/utils/buttonStyleHelpers";
import { getMaxWidthOptions } from "@circle-react-shared/BuilderUI/utils/sizeStyleHelpers";
import { getTextAlignOptions } from "@circle-react-shared/BuilderUI/utils/textStyleHelpers";
import { secondaryBlockDefaultStyles } from "../../Homepage/constants";
import { createTestimonial2Block } from "../Testimonial2/Testimonial2DefaultData";

const cards = [
  {
    userCard: {
      imageSignedId: "",
      placeholder: userImagePlaceholder1,
      header: "Michael Trevez",
      description: "Finance professional",
    },
    content:
      '"Working with Sarah helped me secure a promotion and 40% salary increase while actually working fewer hours. The ROI on this program has been incredible."',
  },
  {
    userCard: {
      imageSignedId: "",
      placeholder: userImagePlaceholder2,
      header: "Jennifer Lorel",
      description: "Entrepreneur",
    },
    content:
      '"I was on the verge of burnout when I started coaching. Now I\'ve doubled my company revenue while working 20 hours less per week and feeling more fulfilled."',
  },
  {
    userCard: {
      imageSignedId: "",
      placeholder: userImagePlaceholder3,
      header: "David Konstas",
      description: "Software Engineer",
    },
    content:
      '"The clarity I gained through this program helped me pivot my career in a direction that aligns with my values. I\'m now doing work I love with people I respect."',
  },
  {
    userCard: {
      imageSignedId: "",
      placeholder: userImagePlaceholder4,
      header: "Sophia Racheal",
      description: "HR Manager",
    },
    content:
      '"The mindset work we did transformed not just my career but my relationships too. For the first time, I feel like I\'m thriving in all areas of my life."',
  },
  {
    userCard: {
      imageSignedId: "",
      placeholder: userImagePlaceholder5,
      header: "James Walter",
      description: "Entrepreneur",
    },
    content:
      '"I was skeptical about coaching, but the structured approach and accountability helped me launch a side business while excelling in my day job."',
  },
  {
    userCard: {
      imageSignedId: "",
      placeholder: userImagePlaceholder6,
      header: "Aisha Meher",
      description: "Non-Profit Leader",
    },
    content:
      '"This program gave me the confidence to step into a leadership role I would have previously thought was beyond my capabilities. Life changing!"',
  },
] as const;

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "TestimonialsBlock3",
  props: {
    header: {
      prop: "children",
      type: "children",
      value: [
        createH2Block({
          text: "Success Stories of Real Clients",
          styles: {
            textAlign: getTextAlignOptions("center"),
            maxWidth: getMaxWidthOptions({
              defaultValue: `${TABLET_WIDTH}px`,
            }),
          },
        }),
        createPBlock({
          text: "Don't just take our word for it, here's what our clients have to say about their transformation.",
          styles: {
            textAlign: getTextAlignOptions("center"),
            maxWidth: getMaxWidthOptions({
              defaultValue: `${TABLET_WIDTH}px`,
            }),
          },
        }),
      ],
    },
    content: {
      prop: "children",
      type: "children",
      value: cards.map(card =>
        createTestimonial2Block({
          content: card.content,
          userCard: {
            signedId: card.userCard.imageSignedId,
            placeholder: card.userCard.placeholder,
            header: card.userCard.header,
            description: card.userCard.description,
          },
        }),
      ),
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        backgroundColor: getBackgroundColorOptions({
          defaultValue: secondaryBlockDefaultStyles.backgroundColor,
        }),
        padding: getPaddingOptions({
          defaultValue: secondaryBlockDefaultStyles.padding,
        }),
        margin: getMarginOptions({
          defaultValue: secondaryBlockDefaultStyles.margin,
        }),
      },
    },
  },
};
